import {ButtonGroup, Tooltip} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import {makeStyles} from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ShoppingCartQuantities} from 'Shared/constants/ShoppingCart';
import {ReducerState} from '../../../../rootReducer';
import {changeCartVisibility, changeViewCart} from '../ducks/Marketing';
import {Marketing} from '../models/Marketing';
import {ReviewCartProps} from './StepCart';

const useStyles = makeStyles(theme => ({
  table: {
    minWidth: 450,
  },
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
    color: '#0033A0',
    fontWeight: 800,
  },
  formNumber: {
    width: '30%',
    padding: '0',
  },
  tableHeader: {
    textAlign: 'center',
    borderBottom: '1px solid black',
    padding: '0',
  },
  quantity: {
    textAlign: 'center',
    paddingLeft: 0,
    paddingRight: 0,
  },
}));

export default function BasicTable({cartData, setActiveStep, setUpdatedCart}: ReviewCartProps) {
  const classes = useStyles();
  const [cartDataCopy, setCartDataCopy] = useState(cartData);
  const setStateData = () => {
    return Array.from(cartDataCopy.items.keys()).map(k => {
      return {[k]: `${cartDataCopy.items.get(k)?.quantity}`};
    });
  };
  const [data, setData] = useState(setStateData());
  const [inQuantityField, setInQuantityField] = useState(false);
  const {inCartVisible} = useSelector((state: ReducerState) => state.marketing);
  const dispatch = useDispatch();

  const clearCart = (e: any) => {
    while (inCartVisible.inCartFormNumber.length > 0) {
      inCartVisible.inCartFormNumber.pop();
    }
    cartDataCopy.items.clear();
    setCartDataCopy({...cartDataCopy});
    dispatch(changeCartVisibility({...inCartVisible}));
  };
  const clearItem = (e: any, formNumber: string) => {
    removeItemFromCart(formNumber);
  };
  const incrementedAmount = (value: any, currentFormIncrement: number) => {
    if (value % currentFormIncrement > 0) {
      return Math.floor(value / currentFormIncrement) * currentFormIncrement + currentFormIncrement;
    } else {
      return value;
    }
  };
  const changeQuantity = (e: any, formNumber: string) => {
    if (!isNaN(e) && e != '' && Number(e) <= 0) {
      cartDataCopy.items.delete(formNumber);
      setCartDataCopy({...cartDataCopy});
      const index = inCartVisible.inCartFormNumber.indexOf(formNumber);
      delete inCartVisible.inCartFormNumber[index];
      dispatch(changeCartVisibility({...inCartVisible}));
    } else {
      if (!isNaN(e) && Number(e) <= 9999) {
        let data: Marketing | undefined = cartDataCopy.items.get(formNumber);
        if (data !== undefined) {
          cartDataCopy.items.set(formNumber, {...data, quantity: e});
        }
        setCartDataCopy({...cartDataCopy});
        setUpdatedCart(cartDataCopy);
      }
    }
  };

  const removeItemFromCart = (formNumber: string) => {
    cartDataCopy.items.delete(formNumber);
    setCartDataCopy({...cartDataCopy});
    const index = inCartVisible.inCartFormNumber.indexOf(formNumber);
    delete inCartVisible.inCartFormNumber[index];
    dispatch(changeCartVisibility({...inCartVisible}));
  };

  const addOne = (formNumber: string) => {
    let data: Marketing | undefined = cartDataCopy.items.get(formNumber);
    const num = data ? Number(data.quantity) + Number(data.unitIncrements) : 0;
    const maxQuantity = data ? Number(data.maxQuantity) : ShoppingCartQuantities.Max;
    if (num <= maxQuantity) {
      if (data !== undefined) {
        cartDataCopy.items.set(formNumber, {...data, quantity: Number(num)});
      }
      setCartDataCopy({...cartDataCopy});
      setUpdatedCart(cartDataCopy);
    }
  };

  const isAtMax = (formNumber: string) => {
    let data: Marketing | undefined = cartDataCopy.items.get(formNumber);
    const num = data ? Number(data.quantity) : 0;
    const maxQuantity = data ? Number(data.maxQuantity) : ShoppingCartQuantities.Max;
    if (num >= maxQuantity) {
      return true;
    }
    return false;
  };

  const subtractOne = (formNumber: string) => {
    let data: Marketing | undefined = cartDataCopy.items.get(formNumber);
    const unitIncrement = data ? Number(data.unitIncrements) : ShoppingCartQuantities.Increment;
    const num = data ? Number(data.quantity) - Number(unitIncrement) : 0;
    const minQuantity = data ? Number(data.minQuantity) : ShoppingCartQuantities.Min;
    if (Number(num) >= minQuantity) {
      cartDataCopy.items.set(formNumber, {...data, quantity: Number(num)});
      setCartDataCopy({...cartDataCopy});
    } else {
      removeItemFromCart(formNumber);
    }
  };

  const handleQuantityFocus = (event: any) => {
    event.target.select();
    setInQuantityField(true);
  };

  const updateQuantity = (e: any, formNumber: string) => {
    if (!isNaN(e) && Number(e) <= 9999) {
      let data: Marketing | undefined = cartDataCopy.items.get(formNumber);
      const unitIncrement = data ? Number(data.unitIncrements) : ShoppingCartQuantities.Increment;
      const maxQuantity = data ? Number(data.maxQuantity) : ShoppingCartQuantities.Max;
      const minQuantity = data ? Number(data.minQuantity) : ShoppingCartQuantities.Min;
      if (e > maxQuantity) {
        e = maxQuantity;
      }
      if (e < minQuantity) {
        e = minQuantity;
      }
      if (data !== undefined) {
        cartDataCopy.items.set(formNumber, {...data, quantity: incrementedAmount(e, unitIncrement)});
      }
      setCartDataCopy({...cartDataCopy});
      setUpdatedCart(cartDataCopy);
    }
    setInQuantityField(false);
  };
  useEffect(() => {
    dispatch(changeViewCart({...cartDataCopy}));
  }, [cartDataCopy]);

  useEffect(() => {
    setData(setStateData());
  }, [cartDataCopy]);

  return (
    <TableContainer component={Paper} variant="outlined" style={{maxHeight: '40rem', padding: '0rem 0rem 1rem 0rem'}}>
      <Table className={classes.table} aria-label="simple table">
        <colgroup>
          <col style={{width: '30%'}} />
          <col style={{width: '30%'}} />
          <col style={{width: '30%'}} />
          <col style={{width: '30%'}} />
        </colgroup>
        <TableHead>
          <TableRow>
            <TableCell className="table-cell" style={{fontWeight: 800, textAlign: 'center'}}>
              Form Number
            </TableCell>
            <TableCell className="table-cell" style={{fontWeight: 800, textAlign: 'center'}}>
              Title
            </TableCell>
            <TableCell className="table-cell" style={{fontWeight: 800, textAlign: 'center'}}>
              Quantity
            </TableCell>
            <TableCell style={{cursor: 'pointer'}}>
              <Button id="clearButtonTable" color="primary" variant="contained" onClick={e => clearCart(e)}>
                Clear
              </Button>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {Array.from(cartDataCopy.items.keys()).map((k, index) => (
            <TableRow key={k}>
              <TableCell
                component="th"
                scope="row"
                align="left"
                className="table-cell"
                style={{width: '30%', paddingLeft: '1rem'}}
              >
                {k}
              </TableCell>
              <Tooltip title={cartDataCopy.items.get(k)?.title!}>
                <TableCell className="table-cell review-cart-title" align="left">
                  {cartDataCopy.items.get(k)?.title}
                </TableCell>
              </Tooltip>
              <TableCell className="table-cell" align="left">
                <ButtonGroup size="small" aria-label="small outlined button group">
                  <Button
                    id="subtract-one-table-btn"
                    variant="text"
                    disabled={inQuantityField}
                    onClick={e => {
                      return subtractOne(k);
                    }}
                  >
                    -
                  </Button>
                  <TextField
                    id="standard-basic"
                    name="changeQuantityName"
                    onFocus={e => handleQuantityFocus(e)}
                    value={cartDataCopy.items.get(k)?.quantity}
                    helperText={new RegExp(/^[0-9 ]+$/).test(data[index]?.[k]) === false ? 'Only numbers allowed' : ''}
                    className={classes.quantity}
                    error={new RegExp(/^[0-9 ]+$/).test(data[index]?.[k]) === false}
                    onBlur={e => {
                      updateQuantity(e.target.value, k);
                    }}
                    onChange={e => {
                      setData([
                        ...data.slice(0, index),
                        Object.assign({}, data[index], {[k]: e.target.value}),
                        ...data.slice(index + 1),
                      ]);
                      changeQuantity(e.target.value, k);
                    }}
                  />
                  <Button
                    id="add-one-table-btn"
                    variant="text"
                    disabled={isAtMax(k) || inQuantityField}
                    onClick={e => {
                      return addOne(k);
                    }}
                  >
                    +
                  </Button>
                </ButtonGroup>
              </TableCell>
              <TableCell align="center" className="table-cell">
                <i
                  className="fa fa-times"
                  aria-hidden="true"
                  style={{color: 'red'}}
                  defaultValue={k}
                  onClick={e => clearItem(e, k)}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
